import { AircraftThresholdMergeResult } from '../../../../../../../monitoring/merger/aircraft-threshold-merger';
import { AirportThresholdMergeResult } from '../../../../../../../monitoring/merger/airport-threshold-merger';
import {
    AircraftThresholdType,
    AirportThresholdType,
    CompanyThresholdsMode,
    ThresholdEnableState,
    ThresholdInfo
} from '../../../../../../../types/thresholds';
import {
    AircraftThresholdAlertClickedArgs,
    AircraftThresholdLevelClickedArgs,
    AircraftThresholdsGridRow,
    AirportThresholdAlertClickedArgs,
    AirportThresholdLevelClickedArgs,
    AirportThresholdsGridRow
} from './ThresholdsGirdRow';
import './ThresholdsGrid.css';

type Props =
    | {
          type: 'aircraft';
          readonly: boolean;
          displayOrder: AircraftThresholdType[];
          data: Record<AircraftThresholdType, AircraftThresholdMergeResult>;
          companyMode: CompanyThresholdsMode;
          thresholdDefinitions: Record<AircraftThresholdType, ThresholdInfo>;
          onPriorityChange?: (type: AircraftThresholdType, value: number) => void;
          onEnableChange?: (type: AircraftThresholdType, value: ThresholdEnableState) => void;
          onLevelClicked?: (args: AircraftThresholdLevelClickedArgs) => void;
          onAlertsClicked?: (args: AircraftThresholdAlertClickedArgs) => void;
      }
    | {
          type: 'airport';
          readonly: boolean;
          displayOrder: AirportThresholdType[];
          data: Record<AirportThresholdType, AirportThresholdMergeResult>;
          companyMode: CompanyThresholdsMode;
          thresholdDefinitions: Record<AirportThresholdType, ThresholdInfo>;
          onPriorityChange?: (type: AirportThresholdType, value: number) => void;
          onEnableChange?: (type: AirportThresholdType, value: ThresholdEnableState) => void;
          onLevelClicked?: (args: AirportThresholdLevelClickedArgs) => void;
          onAlertsClicked?: (args: AirportThresholdAlertClickedArgs) => void;
      };

export function ThresholdsGrid(props: Props) {
    const rows =
        props.type === 'aircraft'
            ? props.displayOrder.map((type) => (
                  <AircraftThresholdsGridRow
                      key={type}
                      readonly={props.readonly}
                      type={type}
                      context={props.data[type]}
                      companyMode={props.companyMode}
                      definitions={props.thresholdDefinitions}
                      onEnableChange={props.onEnableChange}
                      onPriorityChange={props.onPriorityChange}
                      onLevelClicked={props.onLevelClicked}
                      onAlertsClicked={props.onAlertsClicked}
                  />
              ))
            : props.displayOrder.map((type) => (
                  <AirportThresholdsGridRow
                      key={type}
                      readonly={props.readonly}
                      type={type}
                      context={props.data[type]}
                      companyMode={props.companyMode}
                      definitions={props.thresholdDefinitions}
                      onEnableChange={props.onEnableChange}
                      onPriorityChange={props.onPriorityChange}
                      onLevelClicked={props.onLevelClicked}
                      onAlertsClicked={props.onAlertsClicked}
                  />
              ));
    return (
        <div className="position-relative overflow-y-auto px-2 pb-2">
            <div className="thresholds-table" style={{ display: 'grid', gridTemplateColumns: '130px max-content 125px repeat(6, 1fr)' }}>
                <div className="header">Enable</div>
                <div className="header">Item</div>
                <div className="header">Priority</div>
                <div className="header">
                    <div className="level info"></div>
                    Info
                </div>
                <div className="header">
                    <div className="level watch"></div>
                    Watch
                </div>
                <div className="header">
                    <div className="level warning"></div>
                    Warning
                </div>
                <div className="header">
                    <div className="level critical"></div>
                    Critical
                </div>
                <div className="header">
                    <div className="level emergency"></div>
                    Emergency
                </div>
                <div className="header">Alerts</div>

                {rows}
            </div>
            <div
                id="aircraft-thresholds-first-row"
                style={{
                    position: 'absolute',
                    height: 35,
                    left: 0,
                    right: 0,
                    top: 34,
                    pointerEvents: 'none'
                }}></div>
        </div>
    );
}
